var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNotifications(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 25,
    viewBox: "0 0 26 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "notifications"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M12.759 21.897C13.9179 21.897 14.866 20.997 14.866 19.897H10.652C10.652 20.997 11.6002 21.897 12.759 21.897ZM19.08 15.897V10.897C19.08 7.82697 17.3628 5.25697 14.3393 4.57697V3.89697C14.3393 3.06697 13.6334 2.39697 12.759 2.39697C11.8846 2.39697 11.1788 3.06697 11.1788 3.89697V4.57697C8.16579 5.25697 6.43805 7.81697 6.43805 10.897V15.897L4.33105 17.897V18.897H21.187V17.897L19.08 15.897ZM16.973 16.897H8.54505V10.897C8.54505 8.41697 10.1358 6.39697 12.759 6.39697C15.3822 6.39697 16.973 8.41697 16.973 10.897V16.897Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotifications);
export default __webpack_public_path__ + "static/media/Notifications.ed909f541749f029f8c2dc72e139d14e.svg";
export { ForwardRef as ReactComponent };